import { useState, useEffect } from 'react';
import Toast from '../../../core/components/core/Util/Toast/Toast';
import Fetch from "../../../core/util/core/Fetch";
import config from "../../config/config";

const ImportReportsCard = (props) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasProcessing, setHasProcessing] = useState(false);
  const [isPosting, setIsPosting] = useState(false);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [latestCompetency, setLatestCompetency] = useState(null);

  const fetchData = async () => {
    try {
      const response = await Fetch.get(config.endpoints.backend + 'federalrevenue/updateAvaliable')

      if (response) {
        setData(response.lastImportedCompetency?.[0] || null);
        setHasProcessing(response.hasProcessing || isPosting);
        setUpdateAvailable(response.updateAvaliable);
        setLatestCompetency(response.latestCompetency);
      }
    } catch (error) {
      Toast.error('Não foi possível buscar o status das importações.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    setIsPosting(false);
  }, []);

  const handleImport = async () => {
    if (hasProcessing || !updateAvailable) return;

    try {
      setIsPosting(true);

      const response = await Fetch.post(config.endpoints.backend + 'federalrevenue/import', {
        fileCategory: [
          'Cnaes',
          'Motivos',
          'Municipios',
          'Naturezas',
          'Paises',
          'Qualificacoes',
        ]
        // REMOVER ANTES DE SUBIR EM PRODUÇÃO
        // REMOVER ANTES DE SUBIR EM PRODUÇÃO
        // REMOVER ANTES DE SUBIR EM PRODUÇÃO
        // REMOVER ANTES DE SUBIR EM PRODUÇÃO
        // REMOVER ANTES DE SUBIR EM PRODUÇÃO
        // REMOVER ANTES DE SUBIR EM PRODUÇÃO
      })

      if (response.status === 201) {
        Toast.success('Importação disparada com sucesso!');
        fetchData(); // atualiza status após disparar
      } else {
        Toast.error(response.data || 'Não foi possível obter retorno da importação.');
      }
    } catch (error) {
      Toast.error(
        error.response?.data || 'Erro desconhecido ao disparar importação'
      );
    }
  };

  return (
    <section className="content" style={{ marginTop: '30px' }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card card-outline card-info">
              <div className="card-header">
                <h3 className="card-title">
                  <i className="fa-solid fa-database mr-1"></i>
                  Status de Importações
                </h3>
                <div>
                  <button
                    onClick={handleImport}
                    disabled={hasProcessing || isPosting || !updateAvailable}
                    className="btn btn-primary float-right"
                  >
                    {hasProcessing || isPosting
                      ? 'Importação em Andamento'
                      : !updateAvailable
                        ? 'Nenhuma Atualização Disponível'
                        : 'Importar'}
                  </button>

                  <a
                    href="https://monitoring-arf.vercel.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-secondary float-right mr-2"
                  >
                    Últimas Execuções
                  </a>
                </div>
              </div>

              <div className="card-body">
                {isLoading && <p>Carregando...</p>}

                {!isLoading && data && (
                  <div>
                    <p>
                      Última competência importada completamente:{' '}
                      <strong>{data.folder}</strong>
                    </p>
                    <p>Finalizada em {data.import_updated}</p>
                  </div>
                )}

                {!isLoading && !data && <p>Nenhuma importação encontrada.</p>}
                <br></br>
                {!isLoading && updateAvailable && latestCompetency && (
                  <p>
                    ⚡ Existe uma atualização disponível para competência:{' '}
                    <strong>{latestCompetency}</strong>
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImportReportsCard;
